import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft } from "lucide-react";
import { Notice } from "~/components/notice";
import { ParcelCard } from "~/components/parcel-card";
import { Button } from "~/components/ui/button";
import { Skeleton } from "~/components/ui/skeleton";
import { api } from "~/lib/api";

export const Route = createFileRoute("/_authed/_portal/history")({
  component: Delivered,
});

function Delivered() {
  const delivered = useQuery({ queryKey: ["parcels", "archived"], queryFn: () => api.listParcels(true) });
  const parcels = delivered.data ?? [];

  return (
    <div className="space-y-5">
      <Link to="/" className="text-muted-foreground hover:text-foreground -ml-1 inline-flex min-h-11 items-center gap-1 text-[15px] font-medium">
        <ChevronLeft className="size-5" /> Parcels
      </Link>
      <h1 className="type-title">Delivered</h1>

      {delivered.isLoading ? (
        <div className="space-y-3" aria-busy>
          <Skeleton className="h-24 rounded-xl" />
          <Skeleton className="h-24 rounded-xl" />
        </div>
      ) : delivered.isError ? (
        <Notice title="We could not load your delivered parcels" body="Check your connection, then try again.">
          <Button variant="outline" className="h-11 px-5 text-[15px]" onClick={() => void delivered.refetch()}>
            Try again
          </Button>
        </Notice>
      ) : parcels.length === 0 ? (
        <Notice title="Nothing delivered yet" body="Parcels you have received will be listed here." />
      ) : (
        <div className="space-y-3">
          {parcels.map((parcel) => (
            <ParcelCard key={parcel.id} parcel={parcel} />
          ))}
        </div>
      )}
    </div>
  );
}
